export default __webpack_public_path__ + "static/media/QT9 Software.9bdb8dd0.png";